import { NextPageContext } from 'next';
import Head from 'next/head';
import { generateCookieList } from 'common/utils/trackingTag';
import PostTopicPage from 'components/v2/modules/post-topic-page';
import { SITE_BASE_URL } from 'config/env';
import { parse } from 'cookie';

export default function TopicPage({ topic }: { topic: string }): JSX.Element {
  const title = `#${topic}の最新情報 | PostPrime`;
  const description = `#${topic}の最新情報をPostPrimeクリエイターが配信。クリエイターごとの見方や分析を見比べてみましょう。`;
  const url = `${SITE_BASE_URL}/p/post-topic/${topic}`;
  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta property="twitter:url" content={url} />
        <meta name="twitter:card" content="summary_large_image" />
        <link rel="canonical" href={url} />
      </Head>
      <PostTopicPage topicName={topic} />
    </>
  );
}

export const getServerSideProps = (context: NextPageContext) => {
  const cookiesList = generateCookieList(
    context.query,
    parse(context.req?.headers?.cookie || ''),
  );
  if (cookiesList.length > 0) {
    context.res.setHeader('Set-Cookie', cookiesList);
  }
  const topic = (context.query.topic as string) || '';

  return {
    props: {
      topic: topic,
    },
  };
};
